
import HeroSliderCard from './hero-slider-card-desktop'

export default

	components: { HeroSliderCard }

	props:
		block: Object

	data: -> page: 0

	computed:
		classes: -> [
			'theme-light' if @currentSlide?.theme == 'light'
			'theme-dark' if @currentSlide?.theme == 'dark'
			@positioning
		]

		positioning: ->
			switch @block.positionLayout
				when 'topRight' then 'position-top-right'
				when 'bottomLeft' then 'position-bottom-left'
				when 'bottomRight' then 'position-bottom-right'
				else 'position-top-left'

		currentSlide: ->
			return unless @block?.heroSlides?.length
			return @block?.heroSlides[@page]

	methods:
		slideToPage: (page) ->
			return unless @block?.heroSlides?.length
			@page = Math.max(0, Math.min(page, @block?.heroSlides?.length - 1))

